import { refreshToken } from "./auth-utils";
// import {refreshToken as refreshTokenTSID } from "@ts-digital/digital-login-component";
const refreshTokenTSID = () => {};
// Intervallo di millisecondi per ogni controllo del parametro isCheckingTokenDBX in localStorage
const waitingNextAttemptMS = 200;
// Numero massimo di tentativi di controllo del parametro isCheckingTokenDBX
const maxWaitingAttempts = 10;

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function refreshTokenWithQueue(auth, dispatch) {
  return new Promise(async function(resolve, reject) {
    if (!localStorage.getItem("isCheckingTokenDBX") || localStorage.getItem("isCheckingTokenDBX") === "false") {
      localStorage.removeItem("isCheckingTokenDBXResult");
      localStorage.setItem("isCheckingTokenDBX", "true");
      dispatch({
        type: auth.loginAuth.loginMethod === "tsid" ? "CALLWITHRETRY_REFRESH_TOKEN_TSID_START" : "CALLWITHRETRY_REFRESH_TOKEN_START",
        payload: auth.loginAuth ? auth.loginAuth.securityToken : auth.securityToken
      });
      if (auth.loginAuth.loginMethod === "tsid"){        
        refreshTokenTSID(
          auth.loginAuth.refreshToken, "DIGITALBOX", "dev"
        )
          .then((res) => {
            localStorage.setItem("isCheckingTokenDBXResult", res.data.accessToken);
            localStorage.removeItem("isCheckingTokenDBX");
            dispatch({
              type: "CALLWITHRETRY_REFRESH_TOKEN_TSID_SUCCESS",
              payload: {...res.data, securityToken: res.data.accessToken}
            });
            resolve({...res.data, securityToken: res.data.accessToken});
          })
          .catch((err) => {
            localStorage.removeItem("isCheckingTokenDBX");
            dispatch({
              type: "CALLWITHRETRY_REFRESH_TOKEN_TSID_ERROR"
            });
            reject(err);
          });
      } else {
        refreshToken(auth, dispatch)
          .then((token) => {
            localStorage.setItem("isCheckingTokenDBXResult", token);
            localStorage.removeItem("isCheckingTokenDBX");
            dispatch({
              type: "CALLWITHRETRY_REFRESH_TOKEN_SUCCESS",
              payload: token
            });
            resolve(token);
          })
          .catch((err) => {
            localStorage.removeItem("isCheckingTokenDBX");
            dispatch({
              type: "CALLWITHRETRY_REFRESH_TOKEN_ERROR"
            });
            reject(err);
          });
      }
      
    } else {
      for (let i = 0; i <= maxWaitingAttempts; i++) {
        await sleep(waitingNextAttemptMS);
        if (!localStorage.getItem("isCheckingTokenDBX") || localStorage.getItem("isCheckingTokenDBX") === "false") {
          break;
        }
      }
      if (localStorage.getItem("isCheckingTokenDBX") !== "true") {
        resolve(localStorage.getItem("isCheckingTokenDBXResult"));
      } else {
        reject({
          code: 401,
          message: "Can't reset token"
        });
      }
    }
  });
}
